/* global Uploader */
import { Api } from '@/core/api.js'
const api = new Api()

const state = {
  team: {},
  isUploading: false,
  gestorExists: false,
  uniforms: {},
  budget: false
}

const getters = {
  getTeam (state) {
    return state.team
  },

  getBudget (state) {
    return state.budget
  },

  getNumPlayersException (state) {
    var playersException = []
    // avoid errors
    if (
      state.team &&
      state.team.team &&
      state.team.team.category &&
      state.team.team.category.year
    ) {
      var categoryYear = state.team.team.category.year
      // loop for players
      for (var player in state.team.players) {
        // check if player year is smaller than category year
        if (state.team.players[player].birthday < categoryYear) {
          playersException.push(state.team.players[player].id)
        }
      }
      return playersException
    } else {
      return false
    }
  },

  getUniformNumbers (state) {
    var numbers = []
    for (var player in state.team.players) {
      // save id player and number
      numbers[state.team.players[player].id] =
        state.team.players[player].number
    }
    return numbers
  },

  getGestorExists (state) {
    return state.gestorExists
  },

  getUniforms (state) {
    return state.uniforms
  }
}

const actions = {
  loadTeam: ({ commit }, params) => {
    return api.get('team/' + params.team_id + '/summary').then(function (response) {
      if (response.status) {
        return commit('setTeam', response.data)
      }
    })
  },

  loadSanctionsTeam: ({ commit }, params) => {
    return api.get('competition/sanctions/event/' + params.event_id + '/team/' + params.team_id).then(function (response) {
      return response.data
    })
  },

  loadMatchesTeam: ({ commit }, params) => {
    return api.get('competition/matches/event/' + params.event_id + '/team/' + params.team_id).then(function (response) {
      return response.data
    })
  },

  updateTeam: ({ commit }, params) => {
    return api
      .post('team/' + params.team_id + '/update', params.input)
      .then(function (response) {
        return commit('setTeam', response.data)
      })
  },

  removeGestor: ({ commit }, params) => {
    return api
      .get('team/' + params.team_id + '/removeGestor')
      .then(function (response) {
        return response
      })
  },

  addGestor: ({ commit }, params) => {
    return api
      .post('team/' + params.team_id + '/addGestor', params.gestor)
      .then(function (response) {
        return response
      })
  },

  addDisabledGestor: ({ commit }, params) => {
    return api
      .post('team/' + params.team_id + '/addDisabledGestor', params.gestor)
      .then(function (response) {
        return response
      })
  },

  updateEstimatePlayers: ({ commit }, params) => {
    return api
      .post('team/' + params.team_id + '/updateEstimatePersons', params.input)
      .then(function (response) {
        return response
      })
  },

  gestorValidateIfExists: ({ commit }, params) => {
    return api
      .post('user/validate_if_exists', params)
      .then(function (response) {
        return commit('setGestorExists', response.data)
      })
  },

  uploadFiles (context, data) {
    return new Promise((resolve, reject) => {
      var files = data.files
      var uploaderFile = new Uploader()
      uploaderFile.upload(
        files[0],
        {},
        function (data) {
          resolve(data)
        },
        function (e) {
          resolve(e)
        }
      )
    })
  },

  updateInsurance ({ dispatch, commit, rootState }, params) {
    return api
      .post('team/' + params.team_id + '/insurance', { value: params.value })
      .then(function (response) {
        if (response.status) {
          return true
        }
      })
  },

  updateFinals ({ dispatch, commit, rootState }, params) {
    let url = 'team/' + params.team_id + '/finals'
    if (params.saturday) url += '_saturday'
    return api.post(url, { value: params.value }).then(function (response) {
      if (response.status) {
        return true
      }
    })
  },

  updateOpening ({ dispatch, commit, rootState }, params) {
    return api
      .post('team/' + params.team_id + '/opening', { value: params.value })
      .then(function (response) {
        if (response.status) {
          return true
        }
      })
  },

  loadCredential: ({ commit }, params) => {
    return api
      .get('team/' + params.team_id + '/credentials')
      .then(function (response) {
        return response
      })
  },

  updateCredential ({ dispatch, commit, rootState }, params) {
    return api
      .post('team/' + params.team_id + '/credentials/update', {
        value: params.data
      })
      .then(function (response) {
        if (response.status) {
          return true
        }
      })
  },

  loadCredentialsInfo: ({ commit }, params) => {
    return api
      .get('team/' + params.event_id + '/credentials/info')
      .then(function (response) {
        return response.data
      })
  },

  upload (context, data) {
    var teamId = data.team_id
    var team = { ...data.input }
    var filesUpload = []
    filesUpload.push(team.photo)
    context.commit('isUploading', true)
    return context
      .dispatch('uploadFiles', { files: filesUpload, team: team })
      .then(function (response) {
        if (response) {
          // save link from aws
          team.photo = response.Location
          return api
            .post('team/' + teamId + '/update', team)
            .then(function (response) {
              return response
            })
        }
      })
  },

  loadUniforms: ({ commit }, params) => {
    return api
      .get('club/' + params.club_id + '/get-uniforms')
      .then(function (response) {
        return commit('setUniforms', response.data)
      })
  },

  loadBudget: ({ commit }, params) => {
    return api
      .get(
        'finances/budget/' +
          params.event_id +
          '/' +
          params.type +
          '/' +
          params.entity_id
      )
      .then(function (response) {
        return commit('setBudget', response.data)
      })
  },

  assignPersonToRoom: ({ commit }, params) => {
    return api
      .post('team/' + params.team_id + '/assign/person_to_room', {
        rel_room_person_id: params.rel_room_person_id,
        person_id: params.person_id
      })
      .then(function (response) {
        return response
      })
  },

  getLinkImageRight: (context, params) => {
    return api
      .get(
        'link/image-right/team/' +
          params.id +
          '/' +
          params.event_id +
          '/' +
          params.lang
      )
      .then((response) => {
        return response.data
      })
  },

  getImageRightHtml: (context, params) => {
    let url =
      'team/' +
      params.team_id +
      '/imagerights/' +
      params.event_id +
      '/' +
      params.language +
      '/' +
      params.token +
      '/print'

    return api.get(url).then((response) => {
      return response.data
    })
  }
}

const mutations = {
  setTeam (state, value) {
    state.team = value
  },

  setBudget (state, value) {
    state.budget = value
  },

  isUploading (state, value) {
    state.isUploading = false
  },

  setGestorExists (state, value) {
    state.gestorExists = value
  },

  setUniforms (state, value) {
    state.uniforms = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
